export const SET_SUBMIT_FORM = 'setSubmitForm';
export const SET_FORM_ERRORS = 'setFormErrors';
export const SET_FORTNOX = 'setFortnox';